module.exports = __webpack_public_path__ + "img/17.31a115c7.svg";